import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function GPUDedicatedServerIreland() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "GPU Dedicated Server Ireland | High-Performance GPU";
    sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
    <Helmet>
        <title>GPU Dedicated Server Ireland | High-Performance GPU</title>
        <meta name="description" content="Deploy AI, ML, and rendering workloads on GPU dedicated servers in Ireland with NVIDIA GPUs, low latency, full control, and 24/7 support." />
        <meta name="keywords" content="GPU Server Hosting, GPU Dedicated Server Hosting, GPU Dedicated Server Ireland" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/gpu-dedicated-server-ireland`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/gpu-dedicated-server-ireland`} />
        <meta property="og:title" content="GPU Dedicated Servers in Switzerland: Advancing Innovation" />
        <meta property="og:description" content="Power your innovation with GPU Dedicated Servers in Switzerland. Even if it’s for AI, research, or advanced computations, our servers provide high performance." />
    </Helmet>
    <section className="banner-bg bg-dark server-banner special-tilt-pb">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-7 col-xl-6">
                    <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Steady Power, Always.
                    </span>
                    <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    GPU Dedicated Server Ireland? Now, There’s No Going Back
                    </h1>
                    <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Sick of files freezing mid-render? Don’t worry, you’re not alone. But what if we told you there's a GPU dedicated server Ireland that reduces lag just like magic? Even if you are building the next AI model, just like ChatGPT, or 3D designs.
                    </p>
                    <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" data-discover="true">
                            <span className="btn-arrow__text">Get Started
                                <span className="btn-arrow__icon">
                                <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </button>
                        <MinPlanPrice category="customizedgdsire" />
                    </div>
                    <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                </div>
                <div className="col-lg-5 col-xl-6 text-lg-end">
                    <img src="/images/gpu-dedicated-server-ire-banner.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                </div>
            </div>
        </div>
    </section>

    <section className="domain-container position-relative z-1 overflow-hidden special-domain-container">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10">
                        <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                            <div className="card-body pt-60 pb-60">
                                <div className="row justify-content-center">
                                  <div className="col-md-11 col-lg-10 col-xl-10">
                                      <div className="text-center">
                                        <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Up Like Ireland’s Rain.</span>
                                          <h4 className="mb-4">
                                            Select a GPU Dedicated Server That’s Practically Your Neighbor.
                                          </h4>
                                          <p className="mb-6">
                                            Ever felt like your chosen server is playing a catch-up game with your speed? Here’s the secret: Where does your server live? It really matters. Select a GPU dedicated server near you and feel the real difference-no lag, unbeatable speed, and a setup that always keeps up with your energy.
                                          </p>
                                          <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2">
                                              <span className="d-inline-block me-1 flex-shrink-0">
                                                  <i className="las la-comments"></i>
                                              </span>
                                              <span className="btn-arrow__text">
                                                  +91-7737300013
                                                  <span className="btn-arrow__icon">
                                                      <i className="fa-solid fa-arrow-right"></i>
                                                  </span>
                                              </span>
                                          </Link>
                                          <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat">
                                              <span className="d-inline-block me-1 flex-shrink-0">
                                                  <i className="las la-comments"></i>
                                              </span>
                                              <span className="btn-arrow__text">
                                                  Talk to an Expert
                                                  <span className="btn-arrow__icon">
                                                      <i className="fa-solid fa-arrow-right"></i>
                                                  </span>
                                              </span>
                                          </Link>
                                      </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>

    <section className="pt-100 pb-100">
      <div className="pb-40">
          <div className="container">
              <div className="row justify-content-center">
                  <div className="col-md-10 col-lg-8 col-xl-6">
                      <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="300" data-sal-delay="50" data-sal-easing="ease-in-out-sine">
                          <h3>Advanced Hosting Features</h3>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className="container">
          <div className="row g-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
              <div className="col-lg-5">
                  <div className="card h-100">
                      <div className="card-body p-xl-6">
                          <div className="text-center pb-4">
                              <img src="images/advanced-hosting-features.webp" alt="image" className="img-fluid" /> 
                          </div>
                          <h5>
                            Included Features
                          </h5>
                          <div className="pt-4 pb-4">
                              <div className="row g-3">
                                  <div className="col-md-6 col-lg-12 col-xl-6">
                                      <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                                          <li className="d-flex align-items-center gap-2">
                                              <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                                  <i className="fa fa-check"></i>
                                              </div>
                                              <small className="d-inline-block fw-semibold">
                                                  Instant Server Setup
                                              </small>
                                          </li>
                                          <li className="d-flex align-items-center gap-2">
                                              <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                                  <i className="fa fa-check"></i>
                                              </div>
                                              <small className="d-inline-block fw-semibold">
                                                  High-Performance Hardware
                                              </small>
                                          </li>
                                          <li className="d-flex align-items-center gap-2">
                                              <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                                  <i className="fa fa-check"></i>
                                              </div>
                                              <small className="d-inline-block fw-semibold">
                                                  Easy Configuration
                                              </small>
                                          </li>
                                          <li className="d-flex align-items-center gap-2">
                                              <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                                  <i className="fa fa-check"></i>
                                              </div>
                                              <small className="d-inline-block fw-semibold">
                                                  30 Day Moneyback Guarantee
                                              </small>
                                          </li>
                                          <li className="d-flex align-items-center gap-2">
                                              <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                                  <i className="fa fa-check"></i>
                                              </div>
                                              <small className="d-inline-block fw-semibold">
                                                  24/7 Customer Support
                                              </small>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-7">
                  <div className="row g-4">
                      <div className="col-md-6">
                          <div className="card h-100">
                              <div className="card-body p-xl-6">
                                  <div className="mb-10">
                                      <img src="images/own-it-all-from.webp" alt="image" className="img-fluid" />
                                  </div>
                                  <h6>
                                      Uptime You Can Trust
                                  </h6>
                                  <p className="mb-7">
                                      Your business doesn’t sleep, 24/7 & neither should your chosen GPU server. With enterprise-level reliability, this one stays on and up.
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="card h-100">
                              <div className="card-body p-xl-6">
                                  <div className="mb-10">
                                      <img src="images/power-doesnt-give-up.webp" alt="image" className="img-fluid" />
                                  </div>
                                  <h6>
                                      Power Within Budget
                                  </h6>
                                  <p className="mb-7">
                                      Why pay extra money on underpowered hosting? Ughh..This makes no sense. With our GPU dedicated server, you get the demanded performance & storage.
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="card h-100">
                              <div className="card-body p-xl-6">
                                  <div className="mb-10">
                                      <img src="images/next-gen-power.webp" alt="image" className="img-fluid" />
                                  </div>
                                  <h6>
                                      Power You Can Rely On.
                                  </h6>
                                  <p className="mb-7">
                                      You’ve got enough on your plate-your server shouldn’t be one more thing. Even if it’s AI or ML, this one doesn’t shrink. It offers peace every time you log in.
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="card h-100">
                              <div className="card-body p-xl-6">
                                  <div className="mb-10">
                                      <img src="images/the-sweet-spot-server.webp" alt="image" className="img-fluid" />
                                  </div>
                                  <h6>
                                      Quiet Genius, Irish Edition
                                  </h6>
                                  <p className="mb-7">
                                      Heavy projects? We don’t ghost. With Infinitive Host’s robust Intel Xeon cores, this GPU dedicated server manages all your chaos like an expert.
                                  </p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="price-plan-section pt-100 pb-120">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Luck No Templates. Just Personalized Hosting Plans.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'customizedgdsire'}/>
    </section>

    <div className="pt-60 pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/gpu-server-hosting-ireland.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                               Hosting Just Like Calm Skies 
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                GPU Server Hosting Ireland That Gets You
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                You’re crushing really hard-why should your chosen server slow you down? This GPU server hosting Ireland is all about high speed, no static. Ranging from launch to outcomes, it keeps you in flow.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="why-area-one bg-dark pt-60 pb-100 position-relative z-1">
        <div className="container">
            <div className="row align-items-center justify-content-between">
                <div className="col-xl-7">
                    <h2 className="text-white sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Features Designed for Maximum Performance</h2>
                </div>
            </div>
            <div className="mt-8">
                <div className="row g-4">
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition">
                            <img src="images/access-like-a-hacker.webp" alt="image" className="img-fluid"/>
                            <img src="images/access-like-a-hacker-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Access Like a Hacker (But Legally)</h6>
                            <p className="text-white text-opacity-75 mb-0">Ever felt stuck waiting for support all the time just to make a small change? Get complete admin access to handle, install, or delete.</p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition">
                            <img src="images/feeds-on-chaos.webp" alt="image" className="img-fluid"/>
                            <img src="images/feeds-on-chaos-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Feeds on Chaos. Outputs Calm.</h6>
                            <p className="text-white text-opacity-75 mb-0">Big data, deep learning, AI, ML… whatever you wish to run, this GPU server is not here to play with your feelings.
</p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition">
                            <img src="images/no-roommates.webp" alt="image" className="img-fluid"/>
                            <img src="images/no-roommates-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">No Roommates. Just You & Power.</h6>
                            <p className="text-white text-opacity-75 mb-0">Stuck with sharing space all the time? With the help of 100% dedicated hardware, you are in your individual lane.
</p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition">
                            <img src="images/website-data-in-a-vault.webp" alt="image" className="img-fluid"/>
                            <img src="images/website-data-in-a-vault-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Your Website's Data in a Vault.</h6>
                            <p className="text-white text-opacity-75 mb-0">Security shouldn’t be an option or an upgrade-it should be a necessity. Get a free SSL along with every NVIDIA GPU server.</p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition">
                            <img src="images/coffee-break.webp" alt="image" className="img-fluid"/>
                            <img src="images/coffee-break-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Coffee Break → Your Server’s Live</h6>
                            <p className="text-white text-opacity-75 mb-0">No more waiting for days to get started. With the help of our NVIDIA GPU server, your site is up & running in just 4 hours. </p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition">
                            <img src="images/setup-fees.webp" alt="image" className="img-fluid"/>
                            <img src="images/setup-fees-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Setup Fees? That’s So Outdated.</h6>
                            <p className="text-white text-opacity-75 mb-0">Let’s keep it completely real-no hidden setup fees or anything; these are a pure vibe killer. We cut all the fluff. Setup? Umm… Free. </p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition">
                            <img src="images/goes-quite-harder-than.webp" alt="image" className="img-fluid"/>
                            <img src="images/goes-quite-harder-than-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Goes Quite Harder Than Monday</h6>
                            <p className="text-white text-opacity-75 mb-0">Ever had your site go down during launch? Brutal. Our dedicated GPU server hosting is built to stay powerful when things get real. </p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="why-card px-6 py-9 rounded-3 transition">
                            <img src="images/blink-and-see.webp" alt="image" className="img-fluid"/>
                            <img src="images/blink-and-see-dark.webp" alt="image" className="img-fluid dark"/>
                            <h6 className="text-white mt-7">Blink and See It's Loaded in a Blink </h6>
                            <p className="text-white text-opacity-75 mb-0">Lag? Nahhh… Not with us. With the help of 10 Gbps speed, your dedicated GPU server hosting always keeps everything moving. </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
    
    <div className="container pt-100 pb-100">
      <div className="row g-4">
          <div className="col-12">
            <div className="card border-0 roudned-4">
                <div className="card-body pt-60 pb-60 px-md-15">
                  <div className="row g-4 align-items-center justify-content-between">
                      <div className="col-lg-4 sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="cloud-hero__img">
                            <img src="images/favorite-assistant.webp" alt="image" className="img-fluid" />
                        </div>
                      </div>
                      <div className="col-lg-8 col-xl-7">
                        <span className="d-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <span className="d-block w-2 h-2 rounded-circle bg-success"></span>
                        <span className="d-block text-white">
                        <span className="text-success fw-medium">Where Works Settle</span>
                        </span>
                        </span>
                        <h2 className="h3 mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            AI’s Favorite Assistant? This GPU Server.
                        </h2>
                        <div className="row g-3">
                            <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                              <div className="vstack gap-2">
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <span className="d-block fw-medium fs-14">
                                    Troubleshoot Complex Math 
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <span className="d-block fw-medium fs-14"> Crafted to always Think in Parallel</span>
                                  </div>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <span className="d-block fw-medium fs-14">
                                    Train Massive Datasets Without Thinking
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <span className="d-block fw-medium fs-14">
                                    Train Deep Learning Models in Specified Time
                                    </span>
                                  </div>
                              </div>
                            </div>
                            <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                              <div className="vstack gap-2">
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <span className="d-block fw-medium fs-14">
                                    Solves Tons of Calculations in a Single Snap
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <span className="d-block fw-medium fs-14">
                                    Monitor Your Hardware So You Don’t Have To
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <span className="d-block fw-medium fs-14">
                                    Smart Usage = Engaging Performance
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="w-4 h-4 bg-success rounded-circle fs-12 text-white d-flex align-items-center justify-content-center">
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <span className="d-block fw-medium fs-14">
                                    Does More. Consumes Very Less. Stays Cool.
                                    </span>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <button onClick={handlePlanClick} className="btn btn-success btn-arrow btn-arrow-lg btn-lg fs-14 fw-semibold rounded-pill mt-8 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <span className="btn-arrow__text">
                        Explore More
                        <span className="btn-arrow__icon">
                        <i className="fa-solid fa-arrow-right"></i>
                        </span>
                        </span>
                        </button>
                      </div>
                  </div>
                </div>
            </div>
          </div>
      </div>
    </div>
    </>
  );
}
